export enum InstagramOnboardingOptions {
  done_for_you = "done_for_you",
  do_it_myself = "do_it_myself",
}

export enum InstagramOnboardingFlowOption {
  standard = "standard",
  social = "social",
}
